/* Forever Dressed — subtle scroll reveal.
   Fail-safe: only elements starting below the fold are hidden, and if
   IntersectionObserver is unavailable everything is shown immediately. */
(function () {
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function init() {
    var main = document.getElementById('MainContent');
    if (!main) return;
    // Never animate the cart: the checkout button must always be visible.
    if (/^cart/.test(main.getAttribute('data-template') || '')) return;

    var sections = Array.prototype.slice.call(main.children)
      .filter(function (el) { return el.classList && el.classList.contains('shopify-section'); });

    if (!('IntersectionObserver' in window) || sections.length === 0) return;

    var threshold = window.innerHeight * 0.88;
    var targets = sections.filter(function (el) {
      // Never hide content that is already in / near the viewport on load.
      return el.getBoundingClientRect().top > threshold;
    });

    targets.forEach(function (el) { el.classList.add('fd-reveal'); });

    var io = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fd-in');
          obs.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

    targets.forEach(function (el) { io.observe(el); });

    // Safety net: reveal anything still hidden after 2.5s (e.g. observer edge cases)
    setTimeout(function () {
      targets.forEach(function (el) { el.classList.add('fd-in'); });
    }, 2500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* Forever Dressed — mark the page as scrolled so the sticky header can
   switch to its "floating" look (deeper burgundy, hairline, shadow). */
(function () {
  var root = document.documentElement;
  var ticking = false;
  function update() {
    ticking = false;
    var scrolled = (window.scrollY || root.scrollTop || 0) > 8;
    root.classList.toggle('fd-scrolled', scrolled);
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
  }, { passive: true });
  update();
})();
